import React, { useEffect,useState } from "react";
import { Button, Empty,Select,Pagination } from "antd";
import { useNavigate } from "react-router-dom";

import useStatsStore from "../../store/stats.store";
import Filter from "../filter";


import "./jds.scss";
import TeamAssignmentCard from "../TeamAssignmentCard";

export default function JDs(props) {

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };
 
  const {
    getAllJdsInternalConsolidatedStats,
    allJdsInternalConsolidatedStats,
    totalJDsInternalConsolidate
  } = useStatsStore();

  return (
    <div className="teamTask-wrapper">
      <div className="teamTask-title">     
        ({totalJDsInternalConsolidate || 0}){" "} Jobs Found       
      </div>
      <Filter
        filtername = {props.nujobsPost?"getAllJdsInternalConsolidatedStatsNuJobs":"getAllJdsInternalConsolidatedStats"}
        initDuration={props.nujobsPost?"All":"24"}
        initPrio={"All"}
        initResume={"All"}
        initJDStatus={"Active"}
        initClient={"All"}    
        enableDuration
        enableResumes
        enablePriority
        enableJdStatus
        enableCustomers 
        enableTAs     
        handleFilter={getAllJdsInternalConsolidatedStats}
        pageNo={currentPage}
        pageSize={pageSize}
        pageHandler = {setCurrentPage}  
        nujobsPost = {props.nujobsPost}
      />
      <div></div>
      {allJdsInternalConsolidatedStats?.JDListInternalActivity?.length > 0 ? (
      <>
              {allJdsInternalConsolidatedStats?.JDListInternalActivity?.map((jd, idx) => (
                    <TeamAssignmentCard nujobsPost = {props.nujobsPost} data={jd} index= {idx+1 + ((currentPage-1)*pageSize) }/>
              ))}
      </>
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={totalJDsInternalConsolidate}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />
    </div>  
  );
}
